
<template>
  <section class="sm-top admin">
    <div class="sm-wrap lg">
      <div class="sm-top-inner">
        <div class="sm-top__flex">
          <div class="sm-top__row">
            <div class="sm-top__title">
              <a
                v-if="!$route.query.shortcut"
                href="#"
                @click.prevent="$router.push('mail')"
              >
                <include-svg :name="'icon-mail'" />
              </a>
              <h2>{{title}}</h2>
            </div>
          </div>
          <div class="sm-top__controls admin">
            <template v-if="tab == 'single'">
              <input-search
                v-model="search"
                :defaultVal="searchStartVal"
                :placeholder="viewPort != 'small' ? 'Search by Mail ID, Mailbox#, Mail type' : 'Search...'"
                @submit="sendSearchReq"
                @input="checkInput"
              />

              <btn-block
                :type="'small'"
                :text="'Insert Single Mail'"
                :icon="isMobile ? 'icon-mail-single-add' : 'icon-mail'"
                @click="$router.push('new-mail')"
              />
              <btn-block
                :type="'small'"
                :text="'Insert Bulk Mail'"
                :icon="isMobile ? 'icon-mail-group-add' : 'icon-mail-items'"
                @click="$router.push('smart-mail')"
              />
            </template>
            <btn-block
              v-if="tab == 'group'"
              :type="'small'"
              :text="'Create New GroupMail'"
              :icon="'icon-plus'"
              @click="$router.push('new-mail-group')"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Btn from '@/components/Buttons';
import Checkbox from '@/components/Checkboxes';
import IncludeSvg from '@/components/IncludeSvg';
import InputSearch from '@/components/InputSearch';
import {GetMailTypes} from '@/api/general-data';
import Multiselect from 'vue-multiselect';
import DatepickerWrap from '@/components/DatepickerWrap';
import { mapActions, mapGetters } from 'vuex';
import imageStore from '@/utils/image-store';
import ViewPort from '@/mixins/ViewPort';
import RequestsData from '@/settings/action-requests-data';

export default {
  name: 'mail-top',
  components: {
    'btn-block': Btn,
    'checkbox-block': Checkbox,
    'include-svg': IncludeSvg,
    'input-search': InputSearch,
    'dropdown-block': Multiselect,
    'datepicker-wrap': DatepickerWrap
  },
  data() {
    return {
      search: '',
      searchStartVal: '',
      searchTimer: 0,
      searchTimerUpdate: 100,
      seachWait: 1000,
      allowedBreakpoints: [
        'small',
        'large'
      ],
    }
  },
  created() {
    this.searchTimer = setInterval(() => this.searchTimer += this.searchTimerUpdate, this.searchTimerUpdate);
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      provider: 'provider'
    }),
    logo() {
      return imageStore(this.provider.image_url);
    },
    tab() {
      return this.$route.query.tab || 'single';
    },
    title() {
      let res = null;

      if (this.$route.query.shortcut) {
        let key = Object.keys(RequestsData).find(key => RequestsData[key].shortcut == this.$route.query.shortcut);

        if (key)
          return RequestsData[key].text
      }

      if (this.$route.query.tab) {
        return this.$route.query.tab == 'single' ? 'Mail Management' : 'Bulk Shipping';
      }

      return 'Mail Management';
    }
  },
  mixins: [ViewPort],
  methods: {
    clearQueryParams(paramArr) {
      let query = Object.assign({}, this.$route.query);
      paramArr.forEach(param => delete query[param]);

      this.$router.push({query});
    },
    sendSearchReq() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ...{
            search: this.search
          }
        }
      });
    },
    checkInput() {
      if (this.search.length < 2) {
        if (!this.search.length)
          this.clearQueryParams(['search']);

        return;
      }

      setTimeout(() => {
        if (this.searchTimer > this.seachWait) {
          this.sendSearchReq();
          this.searchTimer = 0;
        }
      }, this.seachWait);
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/mail/_top.scss';

   .filtersFade-enter,
   .filtersFade-leave-to {
     transform: scale(1, 0);

     .sm-top__filters-inner {
       opacity: 0;
     }
   }

  .filtersFade-enter-active {
    transition: transform .5s;

    .sm-top__filters-inner {
       transition: opacity .2s .3s;
     }
  }

  .filtersFade-leave-active {
    transition: transform .2s .05s;

    .sm-top__filters-inner {

       transition: opacity .1s;
     }
  }

  .mobileFiltersFade-enter,
  .mobileFiltersFade-leave-to {
    left: 100%;
  }
</style>
